import { z } from "zod";
import { PandadocDocumentStatusSchema } from "@remi/enums/pandadoc-document-status";
import { PandadocDocumentTypeSchema } from "@remi/enums/pandadoc-document-type";

export const PandaDocSubmittedDataTokensKeyValues = [
  "stateCode",
  "homeownerFullName",
  "homeownerAddress",
  "homeownerPhone",
  "addressStreet",
  "city",
  "state",
  "zipCode",
  "lossDate",
  "claimNumber",
  "remiContractorLicense",
  "salespersonFullName",
  "salespersonLicenseNumber",
  "totalCost",
  "financedAmount",
  "isSunrun",
  "buyerOrganizationId",
  "customDocuments",
  "amountDifference",
  "changeOrderDescription",
  "estimatedStartMonth",
  "estimatedStartDay",
  "estimatedStartYear",
  "estimatedCompletionMonth",
  "estimatedCompletionDay",
  "estimatedCompletionYear",
  "isR1",
  "isR2",
  "isR3",
  "hasRoof",
  "hasSolar",
  "hasStructural",
  "structuralLineItems",
  "removalPanels",
  "reinstallPanels",
  "pvSystemCount",
  "colorSelections",
  "roofMaterialsBeingInstalled",
  "previousRoofMaterials",
  "newRoofMaterial",
  "existingRoofMaterial",
  "hasSiding",
  "isPartialSidingWork",
  "hasGutters",
  "isPartialGutterWork",
  "hasRoofGuaranteed",
  "hasRoofNotGuaranteed",
  "workStartedDate",
  "workCompletedDate",
  "partnerFlow",
] as const;

export const PandaDocSubmittedDataCosignerKeyValues = ["email", "phone", "name"] as const;

export const PandaDocSubmittedDataRecipientsKeyValues = ["email", "role", "firstName", "lastName", "phone"] as const;

const PandaDocSubmittedDataKeyValues = ["tokens", "coSigner", "recipients", "hasDealerFeeAddendum"] as const;

const PandaDocSubmittedDataTokensKeySchema = z.enum(PandaDocSubmittedDataTokensKeyValues);
export const PandaDocSubmittedDataTokensKey = PandaDocSubmittedDataTokensKeySchema.enum;
export type PandaDocSubmittedDataTokensKey = (typeof PandaDocSubmittedDataTokensKeyValues)[number];

const PandaDocSubmittedDataCosignerKeySchema = z.enum(PandaDocSubmittedDataCosignerKeyValues);
const PandaDocSubmittedDataCosignerKey = PandaDocSubmittedDataCosignerKeySchema.enum;
type PandaDocSubmittedDataCosignerKey = (typeof PandaDocSubmittedDataCosignerKeyValues)[number];

const PandaDocSubmittedDataRecipientsKeySchema = z.enum(PandaDocSubmittedDataRecipientsKeyValues);
const PandaDocSubmittedDataRecipientsKey = PandaDocSubmittedDataRecipientsKeySchema.enum;
type PandaDocSubmittedDataRecipientsKey = (typeof PandaDocSubmittedDataRecipientsKeyValues)[number];

const PandaDocSubmittedDataKeySchema = z.enum(PandaDocSubmittedDataKeyValues);
const PandaDocSubmittedDataKey = PandaDocSubmittedDataKeySchema.enum;

const PandaDocSubmittedDataTokensSchema = z
  .object({
    [PandaDocSubmittedDataTokensKey.stateCode]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.homeownerFullName]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.homeownerAddress]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.homeownerPhone]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.addressStreet]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.city]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.state]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.zipCode]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.lossDate]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.claimNumber]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.remiContractorLicense]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.salespersonFullName]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.salespersonLicenseNumber]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.totalCost]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.financedAmount]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.isSunrun]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.buyerOrganizationId]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.customDocuments]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.amountDifference]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.changeOrderDescription]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.estimatedStartMonth]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.estimatedStartDay]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.estimatedStartYear]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.estimatedCompletionMonth]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.estimatedCompletionDay]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.estimatedCompletionYear]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.isR1]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.isR2]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.isR3]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.hasRoof]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.hasSolar]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.hasStructural]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.structuralLineItems]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.removalPanels]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.reinstallPanels]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.pvSystemCount]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.colorSelections]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.roofMaterialsBeingInstalled]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.previousRoofMaterials]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.newRoofMaterial]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.existingRoofMaterial]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.hasSiding]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.isPartialSidingWork]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.hasGutters]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.isPartialGutterWork]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.hasRoofGuaranteed]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.hasRoofNotGuaranteed]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.workStartedDate]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.workCompletedDate]: z.string().optional(),
    [PandaDocSubmittedDataTokensKey.partnerFlow]: z.string().optional(),
  })
  .optional()
  .nullable() satisfies z.ZodType<{ [k in PandaDocSubmittedDataTokensKey]?: string | null } | undefined | null>;

const PandaDocSubmittedDataCosignerSchema = z
  .union([
    z.object({
      [PandaDocSubmittedDataCosignerKey.email]: z.string().optional(),
      [PandaDocSubmittedDataCosignerKey.phone]: z.string().optional(),
      [PandaDocSubmittedDataCosignerKey.name]: z.string().optional(),
    }),
    z.null(),
  ])
  .optional() satisfies z.ZodType<{ [k in PandaDocSubmittedDataCosignerKey]?: string | null } | undefined | null>;

const PandaDocSubmittedDataRecipientsSchema = z
  .array(
    z.object({
      [PandaDocSubmittedDataRecipientsKey.email]: z.string(),
      [PandaDocSubmittedDataRecipientsKey.role]: z.string(),
      [PandaDocSubmittedDataRecipientsKey.firstName]: z.string().nullish(),
      [PandaDocSubmittedDataRecipientsKey.lastName]: z.string().nullish(),
      [PandaDocSubmittedDataRecipientsKey.phone]: z.string().optional(),
    }),
  )
  .optional() satisfies z.ZodType<{ [k in PandaDocSubmittedDataRecipientsKey]?: string | null }[] | undefined | null>;

export const PandaDocSubmittedDataSchema = z
  .object({
    [PandaDocSubmittedDataKey.tokens]: PandaDocSubmittedDataTokensSchema,
    [PandaDocSubmittedDataKey.coSigner]: PandaDocSubmittedDataCosignerSchema,
    [PandaDocSubmittedDataKey.recipients]: PandaDocSubmittedDataRecipientsSchema,
    [PandaDocSubmittedDataKey.hasDealerFeeAddendum]: z.boolean().optional(),
  })
  .nullable();

export type PandaDocSubmittedData = z.infer<typeof PandaDocSubmittedDataSchema>;

export const PandadocDocumentSchema = z.object({
  documentId: z.string(),
  status: PandadocDocumentStatusSchema,
  documentType: PandadocDocumentTypeSchema.nullish(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  sentAt: z.coerce.date().nullable(),
  lastViewedAt: z.coerce.date().nullable(),
  completedAt: z.coerce.date().nullable(),
  expiresAt: z.coerce.date().nullable(),
  createdById: z.string(),
  quoteId: z.string().nullish(),
  quoteVersionId: z.string().nullish(),
  fileId: z.string().nullable(),
  submittedData: PandaDocSubmittedDataSchema,
});
